// extracted by mini-css-extract-plugin
export var columnList = "_db-0";